import React, { useEffect, useMemo, useState } from 'react';
import loadMarkdownToHTML from '../editor/utils/loadMarkdownToHTML';

const useParsedMarkdown = (content?: string) => {
  const [markdownToHTML, setMarkdownToHTML] = useState<
    ((markdown: string) => string | null) | null
  >(null);

  useEffect(() => {
    if (content && !markdownToHTML) {
      loadMarkdownToHTML().then((markdownToHTMLFn) =>
        // Can't set directly as `setMarkdownToHTML(markdownToHTMLFn)`
        // because it would trigger the functional version of SetStateAction
        // and call the markdownToHTMLFn with empty input
        setMarkdownToHTML(() => markdownToHTMLFn),
      );
    }
  }, [content, markdownToHTML]);

  return useMemo(() => {
    const markdownHtml =
      content && markdownToHTML ? markdownToHTML(content) : null;

    return markdownHtml ? ( // eslint-disable-next-line react/no-danger
      <div dangerouslySetInnerHTML={{ __html: markdownHtml }} />
    ) : null;
  }, [content, markdownToHTML]);
};

export default useParsedMarkdown;
